// extracted by mini-css-extract-plugin
module.exports = {"root":"footerHelpFloor2_root__1F82_","container":"footerHelpFloor2_container__7pIPA","itemList":"footerHelpFloor2_itemList__2ejHz","item":"footerHelpFloor2_item__1oTLx"};